import { generate } from "library/guid/index.mjs"
import { BusyAdd, BusyRemoved } from "event-definitions"

export function addTempBusy(delay = 25) {
    const id = generate()
    process.env.REACT_APP_DEBUG_BUSY && console.trace("addTempBusy")
    BusyAdd.raise({ id })
    setTimeout(() => BusyRemoved.raise({ id }), delay)
}
